// SPV Pool v1.0 — typed transport for /api/spvs/* (the SPV trust entity).

import { api } from "./client";
import type { PagedResult } from "@/types/api";
import type {
  SpvCreate,
  SpvDto,
  SpvListQuery,
  SpvUpdate,
} from "@/types/spvPool";

export const spvTrustsApi = {
  list: (query?: SpvListQuery) =>
    api.get<PagedResult<SpvDto>>("/spvs", query),
  get: (id: string) => api.get<SpvDto>(`/spvs/${id}`),
  create: (body: SpvCreate) => api.post<SpvDto>("/spvs", body),
  update: (id: string, body: SpvUpdate) =>
    api.put<SpvDto>(`/spvs/${id}`, body),
};
